"use client";

import { createIcon } from "@chakra-ui/react";

const BookmarkSvgIcon = createIcon({
  displayName: "BookmarkSvgIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M18.25 2.75V21.5977L12.416 17.709L12 17.4316L11.584 17.709L5.75 21.5977V2.75H18.25Z"
      stroke=""
      strokeWidth="1.5"
      fill=""
    />
  ),
});

export default BookmarkSvgIcon;
